/**
 * Special effects utility for festive animations
 * Handles CNY and Christmas rain effects using TweenMax
 */

/**
 * Creates animated rain effects for festive seasons
 * @param {string} effectType - Type of effect ('cny' or 'xmas')
 */
export function createRainEffect(effectType) {
  const cssClass = effectType === 'cny' ? 'cny-rain' : 'xmas-rain';

  const getRandomNumber = (min, max) => min + Math.random() * (max - min);

  const animateElement = (element) => {
    const windowHeight = window.innerHeight;
    TweenMax.to(element, getRandomNumber(6, 15), {
      y: windowHeight + 100,
      ease: Linear.easeNone,
      repeat: -1,
      delay: -5
    });
    TweenMax.to(element, getRandomNumber(2, 8), {
      x: '+=100',
      rotationZ: getRandomNumber(0, 180),
      repeat: -1,
      yoyo: true,
      ease: Sine.easeInOut
    });
    TweenMax.to(element, getRandomNumber(2, 8), {
      rotationX: getRandomNumber(0, 360),
      rotationY: getRandomNumber(0, 360),
      repeat: -1,
      yoyo: true,
      ease: Sine.easeInOut,
      delay: -5
    });
  };

  const setupRainLayer = (layerId, elementCount, imageOffset) => {
    TweenLite.set(`#${layerId}`, { perspective: 600 });
    TweenLite.set(`.${layerId} img`, {
      xPercent: imageOffset,
      yPercent: imageOffset
    });

    const container = document.getElementById(layerId);
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    for (let i = 0; i < elementCount; i++) {
      const div = document.createElement('div');
      TweenLite.set(div, {
        attr: { class: layerId },
        x: getRandomNumber(0, windowWidth),
        y: getRandomNumber(-200, -150),
        z: getRandomNumber(-200, 200)
      });
      container.appendChild(div);
      animateElement(div);
    }
  };

  setupRainLayer(`${cssClass}1`, 50, '-30%');
  setupRainLayer(`${cssClass}2`, 30, '-50%');
}
